webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(39);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(91);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Textbox = __webpack_require__(93);
	
	var _Textbox2 = _interopRequireDefault(_Textbox);
	
	var _Footer = __webpack_require__(92);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Textbox: _Textbox2.default, TheFooter: _Footer2.default
	  }
	};

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'footer2',
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'textbox',
	    data: function data() {
	        return {
	            sayThis: '',
	            buttonsDisabled: false,
	            activeVoiceName: null,
	            localVoices: new Array(),
	            count: 0,
	            init: 0,
	            selectedVoice: null,
	            settingsVisible: false
	        };
	    },
	
	    methods: {
	        talk: function talk() {
	            var self = this;
	
	            if (this.sayThis.length == 0) {
	                this.edit();
	                return;
	            }
	
	            var utterance = new SpeechSynthesisUtterance(this.sayThis);
	
	            utterance.addEventListener('start', function () {
	                self.buttonsDisabled = true;
	            });
	
	            utterance.addEventListener('end', function () {
	                self.buttonsDisabled = false;
	                self.edit();
	            });
	
	            utterance.voice = null;
	            if (this.selectedVoice && typeof this.selectedVoice != 'undefined') {
	                var v = null;
	                for (var i = 0; i < this.localVoices.length; i++) {
	                    if (this.localVoices[i].name === this.selectedVoice) {
	                        v = this.localVoices[i];
	                    }
	                }
	                utterance.voice = v;
	            }
	
	            var language = this.detectLanguage();
	            this.log('say' + (utterance.voice && typeof utterance.voice != 'undefined' ? '&voice=' + utterance.voice.name + '(' + utterance.voice.lang + ')' : '') + '&lang=' + language);
	            window.speechSynthesis.speak(utterance);
	        },
	
	        detectLanguage: function detectLanguage() {
	            return navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
	        },
	        edit: function edit() {
	            var input = document.getElementById('sayThis');
	            var len = input.value.length * 2;
	            input.setSelectionRange(len, len);
	            setTimeout(function () {
	                input.focus();
	            }, 5);
	        },
	
	        clearInput: function clearInput() {
	            this.sayThis = '';
	            this.edit();
	        },
	
	        log: function log(action) {
	            var xhr = new XMLHttpRequest();
	            xhr.open('GET', 'static/do.html?action=' + action);
	            xhr.send();
	        },
	
	        checkSpeechsynthesis: function checkSpeechsynthesis() {
	            if (!Modernizr.speechsynthesis) {
	                window.location = "static/noSpeech.html";
	            };
	        },
	
	        populateVoiceList: function populateVoiceList() {
	            var self = this;
	            if (typeof speechSynthesis === 'undefined') {
	                return;
	            }
	
	            if (this.init == 1 || this.localVoices.length > 0) {
	                console.log("already done");
	                return;
	            }
	
	            var voices = speechSynthesis.getVoices();
	
	            setTimeout(function () {
	                self.populateVoiceListNew(voices);
	            }, 500);
	        },
	        populateVoiceListNew: function populateVoiceListNew(voices) {
	            this.count++;
	            console.log('count: ' + this.count);
	
	            this.init = 1;
	            for (var i = 0; i < voices.length; i++) {
	                var v = voices[i];
	                this.localVoices.push(v);
	
	                var option = document.createElement('option');
	                option.textContent = v.name + ' (' + v.lang + ')';
	
	                option.setAttribute('data-lang', v.lang);
	                option.setAttribute('data-name', v.name);
	            }
	
	            console.log(voices.length + ' voices added.');
	
	            if (this.localVoices && this.localVoices.length > 0) {
	                document.getElementById('voiceListContainer').style.display = '';
	            } else {
	                document.getElementById('voiceListContainer').style.display = 'none';
	            }
	        },
	        selectVoice: function selectVoice() {
	            alert('selectVoice');
	        },
	
	        settings: function settings() {
	            this.settingsVisible = !this.settingsVisible;
	        }
	    },
	    mounted: function mounted() {
	        this.checkSpeechsynthesis();
	        if (typeof speechSynthesis !== 'undefined' && speechSynthesis.onvoiceschanged !== undefined) {
	            speechSynthesis.onvoiceschanged = this.populateVoiceList;
	        }
	        document.getElementById("sayThis").focus();
	
	        this.populateVoiceList();
	    }
	};

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "typeHere": "hier schreiben",
	  "voice": "Stimme"
	};

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "typeHere": "type here",
	  "voice": "Voice"
	};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _vue = __webpack_require__(39);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(90);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _de = __webpack_require__(43);
	
	var _de2 = _interopRequireDefault(_de);
	
	var _en = __webpack_require__(44);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	var DEFAULT_LANG = 'de';
	
	function detectLanguage() {
	  return navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
	};
	
	var langs = new _map2.default();
	langs.set('de', _de2.default);
	langs.set('en', _en2.default);
	
	langs.forEach(function (value, key) {
	  console.log(key + '/' + value);
	  _vue2.default.locale(key, value);
	});
	
	var browserLang = detectLanguage();
	console.log('browserLang: ' + browserLang);
	console.log('browserLang: ' + browserLang.substr(0, 2));
	browserLang = browserLang.substr(0, 2);
	
	if (langs.has(browserLang)) {
	  _vue2.default.config.lang = browserLang;
	} else {
	  _vue2.default.config.lang = DEFAULT_LANG;
	}

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(85)
	
	var Component = __webpack_require__(24)(
	  /* script */
	  __webpack_require__(40),
	  /* template */
	  __webpack_require__(95),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(84)
	
	var Component = __webpack_require__(24)(
	  /* script */
	  __webpack_require__(41),
	  /* template */
	  __webpack_require__(94),
	  /* scopeId */
	  "data-v-1bc36556",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(86)
	
	var Component = __webpack_require__(24)(
	  /* script */
	  __webpack_require__(42),
	  /* template */
	  __webpack_require__(96),
	  /* scopeId */
	  "data-v-fc510a98",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "static/impressum.html"
	    }
	  }, [_vm._v("Impressum")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "static/datenschutz.html"
	    }
	  }, [_vm._v("Datenschutz")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://github.com/sebeichholz/letmesayit",
	      "target": "_blank"
	    }
	  }, [_vm._v("Source Code")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/LetMeSayIt.org/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/_icons/FB-f-Logo__blue_29.png",
	      "border": "0",
	      "id": "facebook"
	    }
	  })])])
	}]}

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('textbox'), _vm._v(" "), _c('TheFooter')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "id": "textarea"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.settingsVisible),
	      expression: "!settingsVisible"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sayThis),
	      expression: "sayThis"
	    }],
	    attrs: {
	      "type": "text",
	      "id": "sayThis",
	      "rows": "2",
	      "placeholder": _vm.$t('typeHere') + '...'
	    },
	    domProps: {
	      "value": (_vm.sayThis)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sayThis = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "button-group",
	    attrs: {
	      "id": "divButtons"
	    }
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.settingsVisible),
	      expression: "!settingsVisible"
	    }],
	    staticClass: "large success button noselect",
	    attrs: {
	      "id": "btnTalk",
	      "disabled": _vm.buttonsDisabled
	    },
	    on: {
	      "click": function($event) {
	        _vm.talk()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-comment-alt icon-3x"
	  })]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.settingsVisible),
	      expression: "!settingsVisible"
	    }],
	    staticClass: "large warning button noselect",
	    attrs: {
	      "id": "btnEdit",
	      "disabled": _vm.buttonsDisabled
	    },
	    on: {
	      "click": function($event) {
	        _vm.edit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-edit icon-3x"
	  })]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.settingsVisible),
	      expression: "!settingsVisible"
	    }],
	    staticClass: "large alert button noselect",
	    attrs: {
	      "id": "btnClear",
	      "disabled": _vm.buttonsDisabled
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearInput()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-trash icon-3x"
	  })]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.localVoices.length > 0),
	      expression: "localVoices.length>0"
	    }],
	    staticClass: "large button noselect",
	    class: {
	      hollow: !_vm.settingsVisible
	    },
	    attrs: {
	      "id": "btnSettings",
	      "disabled": _vm.buttonsDisabled
	    },
	    on: {
	      "click": function($event) {
	        _vm.settings()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cogs icon-3x"
	  })])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('form', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.settingsVisible),
	      expression: "settingsVisible"
	    }],
	    attrs: {
	      "id": "settings"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "medium-6 columns"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.localVoices.length > 0),
	      expression: "localVoices.length>0"
	    }],
	    staticClass: "medium-6 columns",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "voiceListContainer"
	    }
	  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('voice')) + ":")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedVoice),
	      expression: "selectedVoice"
	    }],
	    attrs: {
	      "id": "selectVoice"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedVoice = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.localVoices), function(voice) {
	    return _c('option', {
	      domProps: {
	        "value": voice.name
	      }
	    }, [_vm._v("\n                " + _vm._s(voice.lang + ' ' + voice.name) + "\n              ")])
	  }))])])])])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.fccda4c97ea1c3369b15.js